'use client';

import { useLocalStorage } from '@/hooks/useLocalStorage';
import type { FC, PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';
import { useDataPopup } from '../hooks/useDataPopup';
import { useTruth } from '../hooks/useTruth';
import { messages } from '../messages';

interface ConditionSearchParamsProps extends PropsWithChildren {
  amit?: string;
  zdenek?: string;
  vladimir?: string;
  techsquat?: string;
  theDrinkingChat?: string;
  david?: string;
  marta?: string;
}

export const ConditionSearchParams: FC<ConditionSearchParamsProps> = ({
  amit,
  zdenek,
  vladimir,
  techsquat,
  theDrinkingChat,
  david,
  marta,
  children,
}) => {
  const { dataBlocks } = useTruth();
  const { DataPopup } = useDataPopup();
  const { searchParams } = dataBlocks;
  const [handle, setHandle] = useState<React.ReactNode>(children);

  const [localStorage] = useLocalStorage('privacyArticle', {});

  useEffect(() => {
    if (localStorage.lastSearchParamEntity === 'amit') {
      setHandle(amit);
    } else if (localStorage.lastSearchParamEntity === 'zdenek') {
      setHandle(zdenek);
    } else if (localStorage.lastSearchParamEntity === 'vladimir') {
      setHandle(vladimir);
    } else if (localStorage.lastSearchParamEntity === 'techsquat') {
      setHandle(techsquat);
    } else if (localStorage.lastSearchParamEntity === 'theDrinkingChat') {
      setHandle(theDrinkingChat);
    } else if (localStorage.lastSearchParamEntity === 'david') {
      setHandle(david);
    } else if (localStorage.lastSearchParamEntity === 'marta') {
      setHandle(marta);
    } else {
      setHandle(children);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- branch props are static JSX; keyed on the stored entity
  }, [searchParams?.value, localStorage.lastSearchParamEntity]);

  if (!handle) return null;

  return (
    <DataPopup
      handle={handle}
      subheading={messages['condition.searchParams.description']}
      condition={{
        title: messages['condition.searchParams'],
        options: [
          ...(amit ? [{ title: 'Amit', value: amit }] : []),
          ...(zdenek ? [{ title: 'Zdeněk Bárta', value: zdenek }] : []),
          ...(techsquat ? [{ title: 'TechSquat', value: techsquat }] : []),
          ...(theDrinkingChat
            ? [{ title: 'The Drinking Chat', value: theDrinkingChat }]
            : []),
          ...(david ? [{ title: 'David', value: david }] : []),
          ...(marta ? [{ title: 'Marta Bártová', value: marta }] : []),
          { title: 'Unknown', value: children?.toString() || '' },
        ],
      }}
      dataBlocks={{ searchParams }}
    />
  );
};
